import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRuler = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 6.5H2C0.897 6.5 0 7.397 0 8.5V16.5C0 17.603 0.897 18.5 2 18.5H22C23.103 18.5 24 17.603 24 16.5V8.5C24 7.397 23.103 6.5 22 6.5ZM3 11V9C3 8.724 3.224 8.5 3.5 8.5H4.5C4.776 8.5 5 8.724 5 9V11C5 11.276 4.776 11.5 4.5 11.5H3.5C3.224 11.5 3 11.276 3 11ZM7 13V9C7 8.724 7.224 8.5 7.5 8.5H8.5C8.776 8.5 9 8.724 9 9V13C9 13.276 8.776 13.5 8.5 13.5H7.5C7.224 13.5 7 13.276 7 13ZM11 11V9C11 8.724 11.224 8.5 11.5 8.5H12.5C12.776 8.5 13 8.724 13 9V11C13 11.276 12.776 11.5 12.5 11.5H11.5C11.224 11.5 11 11.276 11 11ZM15 13V9C15 8.724 15.224 8.5 15.5 8.5H16.5C16.776 8.5 17 8.724 17 9V13C17 13.276 16.776 13.5 16.5 13.5H15.5C15.224 13.5 15 13.276 15 13ZM19 11V9C19 8.724 19.224 8.5 19.5 8.5H20.5C20.776 8.5 21 8.724 21 9V11C21 11.276 20.776 11.5 20.5 11.5H19.5C19.224 11.5 19 11.276 19 11Z",
		fill: "currentColor"
	})
});
export default SvgRuler;
